module.exports = __webpack_public_path__ + "static/media/all-II-ups-ifu@2x.b4655c44.jpg";